import { ReferralsClient } from 'api/clients/ReferralsClient'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { useEffect, useState } from 'react'

export const useReferralUrl = (): { referralUrl: string } => {
  const [referralUrl, setReferralUrl] = useState('')

  useEffect(() => {
    ReferralsClient.getReferralUrl().then((response) => {
      if (response.type === 'success') {
        setReferralUrl(response.data.promotions[0].referral_link)
      } else {
        ReferralsClient.createReferralUrl().then((response) => {
          if (response.type === 'success') {
            setReferralUrl(response.data.promotions[0].referral_link)
          } else {
            showErrorMessageToast('There was a problem getting your referral URL. Please try again or contact support.')
          }
        })
      }
    })
  }, [])

  return { referralUrl }
}
